/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { useFormik } from "formik";
import { string, object, number } from "yup";
import { Card, CardHeader, CardBody } from "reactstrap";
import moment from "moment";
import api from "../../../Component/axios";
import Swal from "sweetalert2";
import { ReporteDiariaFilter } from "../Diaria/components/Filter";
import { RepoteProyeccionDiaria } from "./components/Table";

const initialValues = {
  inicio: moment().add(1, "day").format("YYYY-MM-DD"),
  fin: moment().add(1, "day").format("YYYY-MM-DD"),
  cultivo: 0,
  campos: [],
};

const ProduccionDiariaGeneral = () => {
  const token = localStorage.getItem("@Token");
  const [loading, setLoading] = useState(false);
  const [variedades, setVariedades] = useState([]);
  const [calibres, setCalibres] = useState([]);
  const [campos, setCampos] = useState([]);
  const [data, setData] = useState([]);

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await api.get(`api/proyeccion-diaria/reporte`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + token,
        },
        params: {
          inicio: values.inicio,
          fin: values.fin,
          campos: JSON.stringify(values.campos),
        },
      });
      const { campos, variedades, calibres, reporte } = response.data;
      setData(reporte);
      setCampos(campos);
      setVariedades(variedades);
      setCalibres(calibres);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Algo salió mal!",
        text: "Favor de comunicarlo con el equipo de desarrollo",
      });
    } finally {
      setLoading(false);
    }
  };

  const { values, errors, touched, handleSubmit, handleChange, setFieldValue } =
    useFormik({
      onSubmit,
      initialValues,
      validationSchema,
    });

  return (
    <Card className="my-2">
      <CardHeader style={{ textAlign: "center" }}>
        <b>Reporte de proyección diaria por campo</b>
      </CardHeader>
      <CardBody>
        <ReporteDiariaFilter
          values={values}
          errors={errors}
          touched={touched}
          handleSubmit={handleSubmit}
          setFieldValue={setFieldValue}
          handleChange={handleChange}
          loading={loading}
        />
        <br />
        <RepoteProyeccionDiaria
          data={data}
          campos={campos}
          size={calibres}
          variedades={variedades}
        />
      </CardBody>
    </Card>
  );
};

const validationSchema = object().shape({
  inicio: string().required(),
  fin: string().required(),
  cultivo: number().moreThan(0).required(),
});

export default ProduccionDiariaGeneral;
